import { LARegion } from "@dana/Common/Constants";
import EmailVerificationPopup from "@dana/Components/EmailVerificationPopup";
import IndividualEmailVerificationPopup from "@dana/Components/IndividualEmailVerificcationPopup";
import Check from "@dana/Icons/Check";
import CheckCircle from "@dana/Icons/CheckCircle";
import CustomerIcon from "@dana/Icons/CustomerIcon";
import EditIcon from "@dana/Icons/EditIcon";
import UserIcon from "@dana/Icons/UserIcon";
import colorPallete from "@dana/MobiusOverrides/styles/variables";
import GlobalPhoneFormat from "@dana/Overrides/Widgets/CreateAccount/FormattPhone";
import infoValidationHandler from "@dana/Store/Data/Accounts/Handlers/InfoValidationHandler";
import StyledWrapper, { getStyledWrapper } from "@insite/client-framework/Common/StyledWrapper";
import validateEmail from "@insite/client-framework/Common/Utilities/validateEmail";
import { makeHandlerChainAwaitable } from "@insite/client-framework/HandlerCreator";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import validatePassword from "@insite/client-framework/Store/CommonHandlers/ValidatePassword";
import validateReCaptcha from "@insite/client-framework/Store/Components/ReCaptcha/Handlers/ValidateReCaptcha";
import { getLanguages, getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import signIn from "@insite/client-framework/Store/Context/Handlers/SignIn";
import addAccount from "@insite/client-framework/Store/Data/Accounts/Handlers/AddAccount";
import { getCurrentCountries } from "@insite/client-framework/Store/Data/Countries/CountriesSelectors";
import { getHomePageUrl } from "@insite/client-framework/Store/Links/LinksSelectors";
import { getCreateAccountReturnUrl } from "@insite/client-framework/Store/Pages/CreateAccount/CreateAccountSelectors";
import translate from "@insite/client-framework/Translate";
import { AccountModel, BaseAddressModel, LanguageModel, StateModel } from "@insite/client-framework/Types/ApiModels";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import ReCaptcha from "@insite/content-library/Components/ReCaptcha";
import Accordion, { AccordionPresentationProps } from "@insite/mobius/Accordion";
import AccordionSection, { AccordionSectionPresentationProps } from "@insite/mobius/AccordionSection";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupPresentationProps } from "@insite/mobius/CheckboxGroup";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { IconPresentationProps } from "@insite/mobius/Icon";
import Icon from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import LoadingOverlay from "@insite/mobius/LoadingOverlay";
import { LoadingSpinnerProps } from "@insite/mobius/LoadingSpinner";
import Modal, { ModalPresentationProps } from "@insite/mobius/Modal";
import Radio from "@insite/mobius/Radio";
import RadioGroup from "@insite/mobius/RadioGroup";
import Select, { SelectPresentationProps, SelectProps } from "@insite/mobius/Select";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import ToasterContext from "@insite/mobius/Toast/ToasterContext";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { ReactNode, RefObject, useContext, useEffect, useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapDispatchToProps = {
    addAccount,
    infoValidationHandler,
    signIn,
    validatePassword,
    validateReCaptcha: makeHandlerChainAwaitable<{ location: string; recaptchaRef: RefObject<ReCAPTCHA | null> }, boolean>(
        validateReCaptcha,
    ),
};

const mapStateToProps = (state: ApplicationState) => {

    return {
        languages: getLanguages(state),
        currentLanguage: state.context.session.language,
        countries: getCurrentCountries(state),
        accountSettings: getSettingsCollection(state).accountSettings,
        returnUrl: getCreateAccountReturnUrl(state),
        homePageUrl: getHomePageUrl(state),
        reCaptchaEnabledForCreateAccount: getSettingsCollection(state).websiteSettings.reCaptchaEnabledForCreateAccount,
    }
}

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface CreateAccountStyles {
    form?: InjectableCss;
    spinner?: LoadingSpinnerProps;
    centeringWrapper?: InjectableCss;
    mainGridContainer?: GridContainerProps;
    userGridItem?: GridItemProps;
    userGridContainer?: GridContainerProps;
    radioGroupcontentWrapper?: InjectableCss;
    danaUserBoxGroupWrapper?: InjectableCss;
    danaUserBoxWrapper?: InjectableCss;
    userIconWrapper?: InjectableCss;
    danaRadioMethodWrapper?: InjectableCss;
    accordionHeadGridItemWrapper?: AccordionPresentationProps;
    accordionHeadGridItem?: AccordionSectionPresentationProps;
    accordionGridItemWrapper?: GridItemProps;
    customerSelectionGridItem?: GridItemProps;
    emailGridItem?: GridItemProps;
    emailTextField?: TextFieldPresentationProps;
    confirmEmailGridItem?: GridItemProps;
    confirmEmailTextField?: TextFieldPresentationProps;
    customerAccountNumberGridItem?: GridItemProps;
    customerAccountNumberTextField?: TextFieldPresentationProps;
    firstNameGridItem?: GridItemProps;
    firstNameTextField?: TextFieldPresentationProps;
    lastNameGridItem?: GridItemProps;
    lastNameTextField?: TextFieldPresentationProps;
    userNameGridItem?: GridItemProps;
    userNameTextField?: TextFieldPresentationProps;
    passwordGridItem?: GridItemProps;
    passwordTextField?: TextFieldPresentationProps;
    passwordIcon?: IconPresentationProps;
    editIconWrapper?: InjectableCss;
    confirmPasswordGridItem?: GridItemProps;
    confirmPasswordTextField?: TextFieldPresentationProps;
    confirmPasswordIcon?: IconPresentationProps;
    confirmationSigninCheckGridItem?: GridItemProps;
    privacyPolicyCheckbox?: CheckboxPresentationProps;
    privacyPolicyCheckboxGroup?: CheckboxGroupPresentationProps;
    submitErrorGridItem?: GridItemProps;
    submitErrorTitle?: TypographyProps;
    nextGridItem?: GridItemProps;
    nextButton?: ButtonPresentationProps;
    backGridItem?: GridItemProps;
    backButton?: ButtonPresentationProps;
    submitGridItem?: GridItemProps;
    reCaptchaGridItem?: GridItemProps;
    submitButton?: ButtonPresentationProps;
    requirementsGridItem?: GridItemProps;
    requirementsTitle?: TypographyProps;
    passwordRequirementsGridItem?: GridItemProps;
    passwordRequirementsGridContainer?: GridContainerProps;
    passwordGridContainer?: GridContainerProps;
    activationInstructionGridItem?: GridItemProps;
    activationInstructionText?: TypographyPresentationProps;
    activationSuccessWrapper?: InjectableCss;
    activationSuccessTitleText?: TypographyPresentationProps;
    activationSuccessMessageText?: TypographyPresentationProps;
    activationSuccessHomeButton?: ButtonPresentationProps;
    addressLine1GridItem?: GridItemProps;
    addressLine1Text?: TextFieldPresentationProps;
    addressLine2GridItem?: GridItemProps;
    addressLine2Text?: TextFieldPresentationProps;
    companyNameGridItem?: GridItemProps;
    companyNameTextField?: TextFieldPresentationProps;
    countryGridItem?: GridItemProps;
    countrySelect?: SelectPresentationProps;
    postalCodeGridItem?: GridItemProps;
    postalCodeText?: TextFieldPresentationProps;
    stateGridItem?: GridItemProps;
    stateSelect?: SelectPresentationProps;
    stateText?: TextFieldPresentationProps;
    cityGridItem?: GridItemProps;
    cityText?: TextFieldPresentationProps;
    phoneGridItem?: GridItemProps;
    phoneText?: TextFieldPresentationProps;
    faxGridItem?: GridItemProps;
    faxText?: TextFieldPresentationProps;
    accountInformationGridContainer?: GridContainerProps;
    accountInformationGridItemWrapper?: GridItemProps;
    billingInformationGridItem?: GridItemProps;
    accountInformationGridItem?: GridItemProps;
    accountInformationHeaderVariant?: TypographyPresentationProps;
    emailVericficationModelPopup?: ModalPresentationProps;
    individualCustomerVericficationModelPopup?: ModalPresentationProps;
    successSignUpMessage?: TypographyPresentationProps;
}

export const createAccountStyles: CreateAccountStyles = {
    mainGridContainer: {
        css: css`
               ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            display: flex;
                            justify-content: center;

                            &>div {
                                display: flex;
                                justify-content: center;
                                flex-wrap: nowrap !important;
                                width: 100% !important;
                                gap: 40px;
                        }
                        `,
                        css`
                        margin: 0 auto;
                        display: flex;
                        justify-content: center;

                        &>div {
                            display: flex;
                            justify-content: center;
                            flex-wrap: nowrap !important;
                            width: 100% !important;
                            gap: 40px;

                        }
                    `,
                    ],
                    "min",
                )}
                
    `,
    },

    centeringWrapper: {
        css: css`
            display: flex;
            height: 300px;
            justify-content: center;
            align-items: center;
        `,
    },

    userGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 15px 0px;
                        `,
                    ],
                    "min",
                )}
        `,
    },

    userGridContainer: {
        gap: 0,
    },
    emailGridItem: {
        width: 12,
    },
    userNameGridItem: {
        width: [12, 12, 6, 6, 6],
    },
    passwordGridItem: {
        width: 12,
    },
    confirmPasswordGridItem: {
        width: 12,
    },
    confirmationSigninCheckGridItem: {
        width: 12,
        css: css`
            padding-top: 20px;
        `,
    },
    submitErrorGridItem: {
        width: 12,
    },
    submitErrorTitle: {
        color: "danger",
    },
    reCaptchaGridItem: { width: 12 },
    submitGridItem: {
        width: 12,
        css: css`
            justify-content: flex-end;
        `,
    },
    requirementsGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            // padding-left: 50px;
                        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    passwordRequirementsGridContainer: {
        gap: 5,
        css: css`

          padding-left: 24px;
          margin-inline-start: 20px;

        div {
             display: list-item;
             list-style-type: disc;
           

             &::marker {
                color: ${colorPallete.primaryRed500};
             }
        }

    `,
    },
    passwordRequirementsGridItem: {
        width: 12,
    },
    requirementsTitle: {
        variant: "h2",
        as: "h2",
    },
    activationInstructionGridItem: {
        width: [12, 12, 6, 6, 6],
        css: css`
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding-left: 50px;
                        `,
                    ],
                    "min",
                )}/* stylelint-disable-line declaration-block-single-line-max-declarations */
        `,
    },
    activationSuccessWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        null,
                        css`
                            width: 50%;
                        `,
                    ],
                    "min",
                )}
        `,
    },
    activationSuccessTitleText: {
        variant: "h3",
    },
    activationSuccessHomeButton: {
        css: css`
            align-self: flex-end;
        `,
    },
};

const styles = createAccountStyles;
const StyledForm = getStyledWrapper("form");
export enum UserTypeConst {
    Customer = "Customer",
    Individual = "ERFQ",
}
export const FormFieldNames = {
    CUSTOMER_ACCOUNT_NUMBER: 'customerAccountNumber',
    USER_NAME: 'userName',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    ADDRESS_LINE1: 'addressLine1',
    ADDRESS_LINE2: 'addressLine2',
    ADDRESS_LINE4: 'addressLine4',
    COMPANY_NAME: 'companyName',
    EMAIL: 'email',
    CONFIRM_EMAIL_ADDRESS: 'confirmEmailAddress',
    PASSWORD: 'password',
    CONFIRM_PASSWORD: 'confirmPassword',
    COUNTRY: 'country',
    STATE: 'state',
    POSTAL_CODE: 'postalCode',
    CITY: 'city',
    PHONE: 'phone',
    FAX: 'fax',
    TERMS: 'terms'
} as const;

type FieldTypesMap = {
    customerAccountNumber: string;
    userName: string;
    firstName: string;
    lastName: string;
    addressLine1: string;
    addressLine2: string;
    addressLine4: string;
    companyName: string;
    email: string;
    confirmEmailAddress: string;
    password: string;
    confirmPassword: string;
    country: string;
    state: string;
    postalCode: string;
    city: string;
    phone: string;
    fax: string;
    terms: boolean;
};

type FormFieldName = typeof FormFieldNames[keyof typeof FormFieldNames];

type FormStateType = {
    [K in FormFieldName]: FieldTypesMap[K];
};
const CreateAccount = ({
    infoValidationHandler,
    addAccount,
    signIn,
    validatePassword,
    validateReCaptcha,
    accountSettings,
    returnUrl,
    history,
    homePageUrl,
    reCaptchaEnabledForCreateAccount,
    countries,
    currentLanguage,
    languages

}: Props) => {

    const FormState: FormStateType = {
        customerAccountNumber: "",
        userName: "",
        firstName: "",
        lastName: "",
        addressLine1: "",
        addressLine2: "",
        addressLine4: "",
        companyName: "",
        email: "",
        confirmEmailAddress: "",
        password: "",
        confirmPassword: "",
        country: "",
        state: "",
        postalCode: "",
        city: "",
        phone: "",
        fax: "",
        terms: false
    };

    const emailFieldMessage = siteMessage("CreateNewAccountInfo_EmailAddress_ValidEmail");
    const invalidCustomerNumberMessage = siteMessage("CreateNewAccountInfo_CustomerNumber_InValid");
    const phoneInvalidFieldMessage = siteMessage("CreateNewAccountInfo_Phone_Invalid");
    const emailAddressCombinationMessage = siteMessage("CreateNewAccountInfo_EmailAddressCombination_DoesNotMatch");
    const passwordCombinationMessage = siteMessage("CreateNewAccountInfo_PasswordCombination_DoesNotMatch");
    const termsLabelMessage = siteMessage("CreateNewAccountInfo_TearmsLabelMessage", 'By clicking on "SIGN UP", I agree to Dana\'s <a target="_blank" ui-sref="policy" class="pzv-color-link ng-binding" href="/privacy-policy">Privacy Policy</a> and <a target="_blank" ui-sref="terms" class="pzv-color-link ng-binding" href="/terms-of-use">Terms of Use</a>.');
    const termsErrorMessage = siteMessage("CreateNewAccountInfo_TearmsToolTip", "You should accept the terms and policies.");
    const [requiredFieldMessage, setRequiredFieldMessage] = useState<string>(siteMessage("CreateNewAccountInfo_Field_Required", "This field is required.").toString());
    const [accountInfoTab, setAccountInfoTab] = useState<boolean>(true);
    const [billingInfoTab, setBillingInfoTab] = useState<boolean>(false);
    const [summeryTab, setSummeryTab] = useState<boolean>(false);
    const [continueToBilling, setContinueToBilling] = useState<boolean>(true);
    const [isAccountInfoSubmitted, setIsAccountInfoSubmitted] = useState(false);
    const [isBillingInfoSubmitted, setIsBillingInfoSubmitted] = useState(false);
    const [isValidatingCustomer, setIsValidatingCustomer] = useState(false);
    const [isValidatingEmail, setIsValidatingEmail] = useState(false);
    const [country, setCountry] = useState<BaseAddressModel["country"]>();
    const [state, setState] = useState<BaseAddressModel["state"]>();
    const [states, setStates] = useState<StateModel[]>();
    const accountFormRef = useRef<HTMLFormElement | null>(null);
    const billingFormRef = useRef<HTMLFormElement | null>(null);
    const summeryFormRef = useRef<HTMLFormElement | null>(null);
    const [individualSuccessPopup, setIndividualSuccessPopup] = useState(false);
    const [customerSuccessPopup, setCustomerSuccessPopup] = useState(false);
    const [account, setAccount] = useState<AccountModel>();
    const [selectedLanguage, setSelectedLanuage] = useState<LanguageModel>();
    useEffect(() => {
        const lang = languages?.find((l: LanguageModel) => l.id === currentLanguage?.id);
        setSelectedLanuage(lang)
    }, [currentLanguage]);

    const closeIndividualPopup = (closeModel = false) => {
        setTimeout(() => {
            signIn({
                userName: useEmailAsUserName ? formState.email : formState.userName,
                password: formState.password,
                rememberMe: false,
                returnUrl,
            });
            setIndividualSuccessPopup(closeModel);
        }, 500);

    }
    const closeCustomerSuccessPopup = (closeModel = false) => {
        //  history.push(returnUrl);
        window.location.href = homePageUrl || returnUrl;
    }
    const [formState, setFormState] = useState({
        ...FormState, errors: {
            customerAccountNumber: "",
            userName: "",
            firstName: "",
            lastName: "",
            addressLine1: "",
            addressLine2: "",
            addressLine4: "",
            companyName: "",
            email: "",
            confirmEmailAddress: "",
            password: "",
            confirmPassword: "",
            country: "",
            state: "",
            postalCode: "",
            city: "",
            phone: "",
            fax: "",
            terms: false
        }
    });

    const [hasErrors, setHasErros] = useState(Object.values(formState.errors).some(error => error));
    useEffect(() => {
        setHasErros(Object.values(formState.errors).some(error => error))
    }, [formState]);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [isSubscribed, setIsSubscribed] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isActivationEmailSent, setIsActivationEmailSent] = useState(false);
    const toasterContext = useContext(ToasterContext);
    const recaptchaRef: RefObject<ReCAPTCHA | null> = React.createRef();

    type UserType = "Customer" | "ERFQ";
    const [userType, setUserType] = useState<UserType>("Customer");
    const {
        useEmailAsUserName,
        requireActivateAccount,
    } = accountSettings;

    const handleInputChange = (e: any) => {
        const { name, value } = e.target;

        let error = '';
        switch (name) {
            case FormFieldNames.CUSTOMER_ACCOUNT_NUMBER:
                error = !value ? requiredFieldMessage : "";
                break;
            case FormFieldNames.USER_NAME:
                error = !value ? accountSettings.useEmailAsUserName ? "" : requiredFieldMessage : "";

                break;
            case FormFieldNames.FIRST_NAME:
                error = !value ? requiredFieldMessage : "";
                break;
            case FormFieldNames.LAST_NAME:
                error = !value ? requiredFieldMessage : "";
                break;
            case FormFieldNames.FAX:

                break;
            case FormFieldNames.EMAIL:
                error = !value ? requiredFieldMessage : validateEmail(value) ? "" : emailFieldMessage?.toString();
                setFormState((prev) => ({
                    ...prev,
                    errors: {
                        ...prev.errors,
                        [FormFieldNames.CONFIRM_EMAIL_ADDRESS]: value !== formState.confirmEmailAddress
                            ? emailAddressCombinationMessage?.toString()
                            : "",
                    }
                }));
                break;
            case FormFieldNames.CONFIRM_EMAIL_ADDRESS:
                error = value !== formState.email
                    ? emailAddressCombinationMessage?.toString()
                    : "";
                break;
            case FormFieldNames.PASSWORD:
            case FormFieldNames.CONFIRM_PASSWORD:
                if (name === FormFieldNames.PASSWORD) {
                    validatePassword({
                        password: value,
                        onComplete: errorMessage => {
                            if (errorMessage) {
                                error = errorMessage?.toString();
                                setFormState((prev) => ({
                                    ...prev,
                                    [name]: value,
                                    errors: {
                                        ...prev.errors,
                                        [name]: error
                                    }
                                }));
                            }
                        },
                    });
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.CONFIRM_PASSWORD]: value !== formState.confirmPassword
                                ? passwordCombinationMessage?.toString()
                                : "",
                        }
                    }));

                } else {
                    error = value !== formState.password
                        ? passwordCombinationMessage?.toString()
                        : "";
                }
                break;
            case FormFieldNames.ADDRESS_LINE1:
            case FormFieldNames.ADDRESS_LINE2:
            case FormFieldNames.ADDRESS_LINE4:
            case FormFieldNames.COMPANY_NAME:
            case FormFieldNames.COUNTRY:
            case FormFieldNames.POSTAL_CODE:
            case FormFieldNames.STATE:
            case FormFieldNames.CITY:
            case FormFieldNames.PHONE:
                error = "";
                break;

            case FormFieldNames.TERMS:

                error = !value ? requiredFieldMessage : "";
                break;
            default:
                return "";

        }

        setFormState((prev) => ({
            ...prev,
            [name]: value,
            errors: {
                ...prev.errors,
                [name]: error
            }
        }));
    };

    const onChangeCountry = (_: React.ChangeEvent<HTMLSelectElement>, country: BaseAddressModel["country"]) => {
        const countryLookup = countries && countries.find(c => c.id === country?.id);
        setCountry(countryLookup);
        setState(undefined);
        setFormState((prev) => ({
            ...prev,
            [FormFieldNames.COUNTRY]: countryLookup ? countryLookup?.id : "",
            [FormFieldNames.STATE]: "",
            [FormFieldNames.ADDRESS_LINE4]: "",
            errors: {
                ...prev.errors,
                [FormFieldNames.COUNTRY]: countryLookup?.id ? "" : ""
            }
        }));

    };

    const onChangeState = (_: React.ChangeEvent<HTMLSelectElement>, state: BaseAddressModel["state"]) => {
        setState(state);
        setFormState((prev) => ({
            ...prev,
            [FormFieldNames.STATE]: state ? state?.id : "",
            errors: {
                ...prev.errors,
                [FormFieldNames.STATE]: state?.id ? "" : ""
            }

        }));
    }

    const handleCountryChange: SelectProps["onChange"] = event => {
        const countryLookup = countries && countries.find(c => c.id === event.target.value);
        onChangeCountry(event, countryLookup || null);
        resetStateTextFieldError();
    };


    const handleStateChange: SelectProps["onChange"] = event => {
        const state = country?.states?.find(s => s.id === event.target.value);
        onChangeState(event, state || null);
        resetStateTextFieldError();
    };
    const resetStateTextFieldError = () => {
        setFormState((prev) => ({
            ...prev,
            errors: {
                ...prev.errors,
                [FormFieldNames.ADDRESS_LINE4]: ""
            }
        }));
    }
    useEffect(() => {
        if (country?.states && country?.states?.length > 1) {
            setStates(country?.states);
        } else {
            setStates([]);
        }
    }, [country]);
    const changePhoneHandler = (): void => {
        validatePhoneHandler()
    }
    const validatePhoneHandler = (): Promise<boolean> => {
        if (!formState.phone) {
            return new Promise((resolve) => {
                resolve(false);
            });
        }

        return new Promise((resolve) => {

            infoValidationHandler({
                phone: formState.phone,
                validateUserPhone: true,
                onSuccess: () => {

                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.PHONE]: ""
                        }
                    }));
                    resolve(true);

                },
                onError: (error: any) => {
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.PHONE]: error
                        }
                    }));
                    resolve(false)
                },
                onComplete(resultProps: any) {

                    if (resultProps.apiResult?.successful) {
                        this.onSuccess?.(resultProps.apiResult.result);
                    } else if (resultProps.apiResult?.errorMessage) {
                        this.onError?.(resultProps.apiResult.errorMessage);
                    }
                },
            });

        });

    };
    const emailChangeHandler = (email: string): void => {
        setIsValidatingEmail(true);
        emailValidateHandler(email);
    }
    const emailValidateHandler = (email: string): Promise<boolean> => {

        if (!email || formState.errors.email !== "") {
            return new Promise((resolve) => {
                resolve(true);
            });
        }

        return new Promise((resolve) => {
            setIsValidatingCustomer(true);
            setIsLoading(true);

            infoValidationHandler({
                email,
                validateUserEmail: true,
                onSuccess: () => {
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.EMAIL]: ""
                        }
                    }));
                    setIsLoading(false);
                    resolve(true);
                },
                onError: (error: any) => {
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.EMAIL]: error
                        }
                    }));
                    setIsLoading(false);
                    resolve(false);
                },
                onComplete(resultProps: any) {
                    setIsLoading(false);
                    if (resultProps.apiResult?.successful) {
                        this.onSuccess?.(resultProps.apiResult.result);
                    } else if (resultProps.apiResult?.errorMessage) {
                        this.onError?.(resultProps.apiResult.errorMessage);
                    }

                },
            });
        });

    };


    const onRegistrationSuccessHandler = (account?: AccountModel) => {
        setErrorMessage("");

        if (userType === UserTypeConst.Individual && account?.activationStatus === "Activated") {
            setAccount(account);
            setIndividualSuccessPopup(true);

        } if (userType === UserTypeConst.Customer) {
            setCustomerSuccessPopup(true);
            setIsActivationEmailSent(true);
        }
        setIsLoading(false);
    };

    const submitHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isSubmitting) {
            setIsSubmitting(true);
        }
        if (!isSubscribed) {
            return false;
        }
        if (!validateAccountInfo(event)) {
            submitAccountInfoHandler(event);
            setIsSubmitting(false);
            return;
        }
        if (!validateBillingInfo(event)) {
            submitBillingInfoHandler(event);
            setIsSubmitting(false);
            return;
        }


        const isReCaptchaValid = await validateReCaptcha({ location: "CreateAccount", recaptchaRef });

        if (!isReCaptchaValid) {
            setIsSubmitting(false);
            return;
        }
        setIsLoading(true);
        setIsSubmitted(true);
        addAccount({
            email: formState.email,
            userName: formState.userName,
            password: formState.password,
            isSubscribed,
            firstName: formState.firstName,
            lastName: formState.lastName,
            properties: {
                registeredCustomerNumber: (userType === UserTypeConst.Customer ? formState.customerAccountNumber : ""),
                addressLine1: formState.addressLine1,
                addressLine2: formState.addressLine2,
                addressLine4: formState.addressLine4,
                postalCode: formState.postalCode,
                country: formState.country,
                state: formState.state,
                city: formState.city,
                company: formState.companyName,
                phone: formState.phone,
                fax: formState.fax,
                userType,
            },
            onSuccess: onRegistrationSuccessHandler,
            onError: (error: any) => {
                setErrorMessage(error);
                setIsSubmitted(false);

            },
            onComplete(resultProps: any) {
                setIsLoading(false);
                if (resultProps.apiResult?.successful) {
                    this.onSuccess?.(resultProps.apiResult.result);
                } else if (resultProps.apiResult?.errorMessage) {
                    this.onError?.(resultProps.apiResult.errorMessage);

                }

            },
        } as any);
    };

    const homeClickHandler = () => {
        history.push(homePageUrl);
    };

    const handleUserTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value as UserType;
        if (value === UserTypeConst.Individual) {
            setFormState((prev) => ({
                ...prev,
                [FormFieldNames.CUSTOMER_ACCOUNT_NUMBER]: "",
                errors: {
                    ...prev.errors,
                    [FormFieldNames.CUSTOMER_ACCOUNT_NUMBER]: ""
                }
            }));
        }
        setUserType(value);
    };

    const submitAccountInfoHandler = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsAccountInfoSubmitted(true);

        if (!validateAccountInfo(event)) {
            setIsLoading(false)
            return;
        }

        if (userType === UserTypeConst.Customer) {
            const isValidateNumber = await customerAccountNumberValidateHandler();
            if (!isValidateNumber) {
                setIsLoading(false)
                return;
            }
        }

        const isEmailValidate = await emailValidateHandler(formState.email);
        if (!isEmailValidate) {
            setIsLoading(false)
            return;
        }


        setAccountInfoTab(false);
        setBillingInfoTab(true);

    };

    const changeCustomerAccountNumberHandler = (): void => {
        customerAccountNumberValidateHandler();
    }
    const customerAccountNumberValidateHandler = (): Promise<boolean> => {

        if (!formState.customerAccountNumber) {
            return new Promise((resolve) => {
                return resolve(false);
            });
        }


        return new Promise((resolve) => {
            setIsValidatingCustomer(true);
            setIsLoading(true);

            infoValidationHandler({
                registeredCustomerNumber: formState.customerAccountNumber,
                validateCustomerNumber: true,
                onSuccess: () => {
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.CUSTOMER_ACCOUNT_NUMBER]: ""
                        }
                    }));
                    setIsLoading(false);
                    resolve(true);
                },
                onError: (error: any) => {
                    setIsLoading(false);
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [FormFieldNames.CUSTOMER_ACCOUNT_NUMBER]: invalidCustomerNumberMessage?.toString()
                        }
                    }));
                    resolve(false);
                },
                onComplete(resultProps: any) {
                    if (resultProps.apiResult?.successful) {
                        this.onSuccess?.(resultProps.apiResult.result);
                    } else if (resultProps.apiResult?.errorMessage) {
                        this.onError?.(resultProps.apiResult.errorMessage);
                    }
                    setIsLoading(false);
                },
            });
        });
    };

    const submitBillingInfoHandler = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isBillingInfoSubmitted) {
            setIsBillingInfoSubmitted(true);
        }

        if (formState.phone !== "" && !validatePhoneHandler()) {
            return;
        }

        if (!validateBillingInfo(event)) {
            submitAccountInfoHandler(event);
            return;
        }

        if (hasErrors) {
            setIsLoading(false)
            return;
        }

        setBillingInfoTab(false);
        setSummeryTab(true);
    }

    const validateSummeryInfo = (event: any) => {
        event.preventDefault();
        return isSubscribed;
    }
    const validateBillingInfo = (event: any) => {
        event.preventDefault();
        let canContinue = true;
        const formElement = billingFormRef.current;
        if (!formElement) { return false; }
        const requiredFields = formElement.querySelectorAll('[required]');

        const invalidFields = [];

        requiredFields.forEach((field: any) => {
            if (!field.value.trim()) {
                invalidFields.push(field);
                setFormState((prev) => ({
                    ...prev,
                    errors: {
                        ...prev.errors,
                        [field.name]: requiredFieldMessage
                    }
                }));
                field.classList.add('error');

            }
        });

        if (invalidFields.length > 0) {
            setBillingInfoTab(true);
            canContinue = false;
        } else {
            canContinue = true;
        }

        return canContinue;
    }
    const validateAccountInfo = (event: any) => {
        event.preventDefault();
        let canContinue = true;
        const formElement = accountFormRef.current;

        if (!formElement) { return; }
        const requiredFields = formElement.querySelectorAll('[required]');

        const invalidFields = [];

        requiredFields.forEach((field: any) => {
            if (!field.value.trim()) {
                if ((field.name !== FormFieldNames.CONFIRM_EMAIL_ADDRESS &&
                    field.name !== FormFieldNames.CONFIRM_PASSWORD)) {
                    invalidFields.push(field);
                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [field.name]: requiredFieldMessage
                        }
                    }));
                    field.classList.add('error'); // optional styling
                } else if (field.name === FormFieldNames.CONFIRM_PASSWORD) {

                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [field.name]: field.value !== formState.password
                                ? passwordCombinationMessage?.toString()
                                : ""
                        }
                    }));
                    if (field.value !== formState.password) {
                        invalidFields.push(field);
                    }
                } else if (field.name === FormFieldNames.CONFIRM_EMAIL_ADDRESS) {

                    setFormState((prev) => ({
                        ...prev,
                        errors: {
                            ...prev.errors,
                            [field.name]: field.value !== formState.email
                                ? emailAddressCombinationMessage?.toString()
                                : ""
                        }
                    }));
                    if (field.value !== formState.email) {
                        invalidFields.push(field);
                    }
                }
            } else {
                field.classList.remove('error');
            }
        });
        requiredFields.forEach((field: any) => {

            if (field.name === FormFieldNames.CONFIRM_PASSWORD) {

                setFormState((prev) => ({
                    ...prev,
                    errors: {
                        ...prev.errors,
                        [field.name]: field.value !== formState.password
                            ? passwordCombinationMessage?.toString()
                            : ""
                    }
                }));
                if (field.value !== formState.password) {
                    invalidFields.push(field);
                }
            } else if (field.name === FormFieldNames.CONFIRM_EMAIL_ADDRESS) {

                setFormState((prev) => ({
                    ...prev,
                    errors: {
                        ...prev.errors,
                        [field.name]: field.value !== formState.email
                            ? emailAddressCombinationMessage?.toString()
                            : ""
                    }
                }));
                if (field.value !== formState.email) {
                    invalidFields.push(field);
                }
            }

        });


        if (userType === UserTypeConst.Customer && (formState.errors.customerAccountNumber || formState.customerAccountNumber === "")) {
            canContinue = false;
        }
        if (invalidFields.length > 0) {
            setAccountInfoTab(true);
            canContinue = false;
        } else {
            canContinue = true;
        }

        return canContinue;
    }
    const backToAccountInformationHadler = () => {
        setBillingInfoTab(false);
        setAccountInfoTab(true);
    }
    const jumpToBillingTab = () => {
        setAccountInfoTab(false);
        setBillingInfoTab(true);
        setSummeryTab(false);
    }
    const jumpToInfoTab = () => {
        setAccountInfoTab(true);
        setBillingInfoTab(false);
        setSummeryTab(false);
    }
    console.log(formState);
    const checkIcon = (
        <StyledWrapper
            className="checkIcon"
        >
            <CheckCircle />
        </StyledWrapper>);

    return (
        <>
            {customerSuccessPopup && <Modal {...styles.emailVericficationModelPopup}
                isOpen={customerSuccessPopup}
                handleClose={() => closeCustomerSuccessPopup(true)}
                isCloseable={false}
            >
                <EmailVerificationPopup closeCustomerSuccessPopup={closeCustomerSuccessPopup} />
            </Modal>
            }
            {individualSuccessPopup && <Modal {...styles.individualCustomerVericficationModelPopup}
                key={account?.id}
                isOpen={individualSuccessPopup}
                headline={
                    <>
                        <Icon src={Check} size={24} className="check-icon" />
                        <Typography variant="h6" {...styles.successSignUpMessage}>{translate("Hi")}  {account?.firstName}! {translate("you have signed up successfully.")}</Typography>
                    </>
                }
                handleClose={() => closeIndividualPopup(true)}
                isCloseable={false}
            >
                <IndividualEmailVerificationPopup account={account} closeIndividualPopup={closeIndividualPopup} />
            </Modal>
            }
            <LoadingOverlay loading={isLoading}>

                <GridContainer {...styles.mainGridContainer}>
                    <GridItem {...styles.userGridItem}>
                        <GridContainer {...styles.userGridContainer}>
                            <GridItem {...styles.accordionGridItemWrapper}>
                                <Accordion {...styles.accordionHeadGridItemWrapper}
                                    headingLevel={4}
                                    mergeCss={true}
                                    className="accordionMainContainer"
                                >
                                    <AccordionSection {...styles.accordionHeadGridItem}
                                        title={translate("Account Information")}
                                        expanded={accountInfoTab}
                                    >
                                        <StyledForm ref={accountFormRef}  {...styles.form} onSubmit={submitAccountInfoHandler} noValidate>

                                            <GridContainer>
                                                <GridItem {...styles.customerSelectionGridItem}>
                                                    <StyledWrapper {...styles.radioGroupcontentWrapper}>
                                                        <RadioGroup
                                                            label={translate("Customer")}
                                                            data-test-selector="areyouadanacustomer"
                                                            onChangeHandler={handleUserTypeChange}
                                                            {...styles.danaUserBoxGroupWrapper}
                                                            value={userType}
                                                        >
                                                            <StyledWrapper
                                                                {...styles.danaRadioMethodWrapper}
                                                                className={userType === UserTypeConst.Customer ? "active" : ""}
                                                            >
                                                                <Radio value={UserTypeConst.Customer} data-test-selector="areyouadanacustomer_yes" {...styles.danaUserBoxWrapper}>
                                                                    <Icon src={CustomerIcon} size={30} className="user-icon" {...styles.userIconWrapper} />
                                                                    <Typography>{translate("Customer")}</Typography>
                                                                </Radio>
                                                                {userType === UserTypeConst.Customer && checkIcon}

                                                            </StyledWrapper>
                                                            {selectedLanguage?.properties?.region === "Mark" && (
                                                                <StyledWrapper
                                                                    {...styles.danaRadioMethodWrapper}
                                                                    className={userType === UserTypeConst.Individual ? "active" : ""}
                                                                >
                                                                    <Radio value={UserTypeConst.Individual} data-test-selector="areyouadanacustomer_no" {...styles.danaUserBoxWrapper}>
                                                                        <Icon src={UserIcon} size={30} className="user-icon" {...styles.userIconWrapper} />
                                                                        <Typography>{translate("Individual")}</Typography>
                                                                    </Radio>
                                                                    {userType === UserTypeConst.Individual && checkIcon}
                                                                </StyledWrapper>
                                                            )}

                                                        </RadioGroup>
                                                    </StyledWrapper>
                                                </GridItem>

                                                {userType === UserTypeConst.Customer && (
                                                    <>
                                                        <GridItem {...styles.customerAccountNumberGridItem}>
                                                            <TextField
                                                                {...styles.customerAccountNumberTextField}
                                                                label={translate("Customer Account Number")}
                                                                name={FormFieldNames.CUSTOMER_ACCOUNT_NUMBER}
                                                                onChange={handleInputChange}
                                                                onBlur={changeCustomerAccountNumberHandler}
                                                                value={formState.customerAccountNumber}
                                                                data-test-selector="createAccount_customeraccountnumber"
                                                                maxLength={256}
                                                                required
                                                                error={(isAccountInfoSubmitted || isValidatingCustomer) && formState.errors?.customerAccountNumber}
                                                            />
                                                        </GridItem>

                                                        <GridItem {...styles.customerAccountNumberGridItem}>

                                                        </GridItem>
                                                    </>
                                                )}

                                                <GridItem {...styles.firstNameGridItem}>
                                                    <TextField
                                                        {...styles.firstNameTextField}
                                                        label={translate("First Name")}
                                                        onChange={handleInputChange}
                                                        name={FormFieldNames.FIRST_NAME}
                                                        value={formState.firstName}
                                                        data-test-selector="createAccount_firstname"
                                                        maxLength={256}
                                                        required
                                                        error={isAccountInfoSubmitted && formState.errors?.firstName}
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.lastNameGridItem}>
                                                    <TextField
                                                        {...styles.lastNameTextField}
                                                        label={translate("Last Name")}
                                                        onChange={handleInputChange}
                                                        name={FormFieldNames.LAST_NAME}
                                                        value={formState.lastName}
                                                        data-test-selector="createAccount_lastname"
                                                        maxLength={256}
                                                        required
                                                        error={isAccountInfoSubmitted && formState.errors?.lastName}
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.emailGridItem}>
                                                    <TextField
                                                        autoComplete="off"
                                                        {...styles.emailTextField}
                                                        type="email"
                                                        label={translate("Email Address")}
                                                        onChange={handleInputChange}
                                                        onBlur={e => emailChangeHandler(e.currentTarget.value)}
                                                        name={FormFieldNames.EMAIL}
                                                        value={formState.email}
                                                        data-test-selector="createAccount_email"
                                                        maxLength={256}
                                                        required
                                                        error={(isAccountInfoSubmitted || isValidatingEmail) && formState.errors?.email}
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.confirmEmailGridItem}>
                                                    <TextField
                                                        {...styles.confirmEmailTextField}
                                                        type="email"
                                                        autoComplete="off"
                                                        label={translate("Confirm Email Address")}
                                                        onChange={handleInputChange}
                                                        name={FormFieldNames.CONFIRM_EMAIL_ADDRESS}
                                                        value={formState.confirmEmailAddress}
                                                        data-test-selector="createAccount_confirmemail"
                                                        maxLength={256}
                                                        required
                                                        error={isAccountInfoSubmitted && formState.errors?.confirmEmailAddress}
                                                    />
                                                </GridItem>

                                                {!useEmailAsUserName && (
                                                    <GridItem {...styles.userNameGridItem}>
                                                        <TextField
                                                            {...styles.userNameTextField}
                                                            label={translate("User Name")}
                                                            name={FormFieldNames.USER_NAME}
                                                            value={formState.userName}
                                                            data-test-selector="createAccount_userName"
                                                            onChange={handleInputChange}
                                                            error={isAccountInfoSubmitted && formState.errors?.userName}
                                                            maxLength={256}
                                                            required
                                                        />
                                                    </GridItem>
                                                )}

                                                {!requireActivateAccount && (
                                                    <>
                                                        <GridItem {...styles.passwordGridItem}>
                                                            <TextField
                                                                id="password"
                                                                {...styles.passwordTextField}
                                                                type={showPassword ? undefined : "password"}
                                                                label={translate("Password")}
                                                                name={FormFieldNames.PASSWORD}
                                                                autoComplete="off"
                                                                value={formState.password}
                                                                onChange={handleInputChange}
                                                                error={isAccountInfoSubmitted && formState.errors?.password}
                                                                iconProps={{ ...styles.passwordIcon, src: showPassword ? EyeOff : Eye }}
                                                                iconClickableProps={{
                                                                    onClick: () => {
                                                                        setShowPassword(!showPassword);
                                                                    },
                                                                    type: "button",
                                                                }}
                                                                clickableText={formState.password}
                                                                data-test-selector="createAccount_password"
                                                                required
                                                            />
                                                        </GridItem>
                                                        <GridItem {...styles.confirmPasswordGridItem}>
                                                            <TextField
                                                                id="confirm-password"
                                                                autoComplete="off"
                                                                {...styles.confirmPasswordTextField}
                                                                type={showConfirmPassword ? undefined : "password"}
                                                                label={translate("Confirm Password")}
                                                                name={FormFieldNames.CONFIRM_PASSWORD}
                                                                value={formState.confirmPassword}
                                                                onChange={handleInputChange}
                                                                error={isAccountInfoSubmitted && formState.errors?.confirmPassword}
                                                                iconProps={{
                                                                    ...styles.confirmPasswordIcon,
                                                                    src: showConfirmPassword ? EyeOff : Eye,
                                                                }}
                                                                iconClickableProps={{
                                                                    onClick: () => {
                                                                        setShowConfirmPassword(!showConfirmPassword);
                                                                    },
                                                                    type: "button",
                                                                }}
                                                                clickableText={formState.confirmPassword}
                                                                data-test-selector="createAccount_confirmPassword"
                                                                required
                                                            />
                                                        </GridItem>
                                                    </>
                                                )}

                                                <GridItem {...styles.nextGridItem}>
                                                    <Button
                                                        {...styles.nextButton}
                                                        type="submit"
                                                        data-test-selector="createAccount_ContinueToBillingButton"
                                                    >
                                                        {translate("Continue")}
                                                    </Button>
                                                </GridItem>

                                                {errorMessage && (
                                                    <GridItem data-test-selector="createAccount_ErrorMessage" {...styles.submitErrorGridItem}>
                                                        <Typography {...styles.submitErrorTitle}>{errorMessage}</Typography>
                                                    </GridItem>
                                                )}
                                                {reCaptchaEnabledForCreateAccount && (
                                                    <GridItem {...styles.reCaptchaGridItem}>
                                                        <ReCaptcha recaptchaRef={recaptchaRef} location="CreateAccount" />
                                                    </GridItem>
                                                )}
                                            </GridContainer>
                                        </StyledForm>
                                    </AccordionSection>

                                    <AccordionSection
                                        title={translate("Address")}
                                        expanded={billingInfoTab}
                                        {...styles.accordionHeadGridItem}>
                                        <StyledForm ref={billingFormRef} {...styles.form} onSubmit={submitBillingInfoHandler} noValidate>

                                            <GridContainer>
                                                <GridItem {...styles.addressLine1GridItem}>
                                                    <TextField {...styles.addressLine1Text}
                                                        id={FormFieldNames.ADDRESS_LINE1}
                                                        label={translate("Address Line 1")}
                                                        name={FormFieldNames.ADDRESS_LINE1}
                                                        value={formState.addressLine1}
                                                        maxLength={256}
                                                        onChange={(e) => handleInputChange(e)}
                                                        //    error={isBillingInfoSubmitted && formState.errors.addressLine1}
                                                        data-test-selector="createAccount_addressLine1"
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.addressLine2GridItem}>
                                                    <TextField {...styles.addressLine2Text}
                                                        label={translate("Address Line 2")}
                                                        name={FormFieldNames.ADDRESS_LINE2}
                                                        value={formState.addressLine2}
                                                        maxLength={256}
                                                        onChange={(e) => handleInputChange(e)}
                                                        data-test-selector="createAccount_addressLine2"
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.companyNameGridItem}>
                                                    <TextField {...styles.companyNameTextField}
                                                        label={translate("Company Name")}
                                                        name={FormFieldNames.COMPANY_NAME}
                                                        value={formState.companyName}
                                                        maxLength={256}
                                                        onChange={handleInputChange}
                                                        error={userType === UserTypeConst.Customer && isBillingInfoSubmitted && formState.errors.companyName}
                                                        data-test-selector="createAccount_companyName"
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.countryGridItem}>
                                                    <Select {...styles.countrySelect}
                                                        label={translate("Country")}
                                                        name={FormFieldNames.COUNTRY}
                                                        value={country?.id}
                                                        onChange={handleCountryChange}
                                                        error={isBillingInfoSubmitted && formState.errors.country}
                                                        data-test-selector="createAccount_country"
                                                    >
                                                        <option value="">{translate("Select Country")}</option>
                                                        {countries && countries.map(co => (
                                                            <option key={co.id} value={co.id}>
                                                                {co.name}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </GridItem>

                                                <GridItem {...styles.postalCodeGridItem}>
                                                    <TextField
                                                        {...styles.postalCodeText}

                                                        label={translate("Zip/PostalCode")}
                                                        name={FormFieldNames.POSTAL_CODE}
                                                        value={formState.postalCode}
                                                        maxLength={256}
                                                        onChange={handleInputChange}
                                                        error={isBillingInfoSubmitted && formState.errors.postalCode}
                                                        data-test-selector="customerAddressForm_postalCode"
                                                    />
                                                </GridItem>
                                                <GridItem {...styles.stateGridItem}>
                                                    {states && states?.length > 0 &&
                                                        (<Select
                                                            {...styles.stateSelect}
                                                            label={translate("State/Province/Region")}
                                                            name={FormFieldNames.STATE}
                                                            value={formState.state}
                                                            onChange={handleStateChange}
                                                            error={isBillingInfoSubmitted && formState.errors.state}
                                                            data-test-selector="customerAddressForm_state"
                                                        >
                                                            <option value="">{translate("Select State")}</option>
                                                            {states && states.map(st => (
                                                                <option key={st.id} value={st.id}>
                                                                    {st.name}
                                                                </option>
                                                            ))}
                                                        </Select>)
                                                    }
                                                    {states?.length === 0 && (
                                                        <TextField
                                                            {...styles.stateText}
                                                            label={translate("State/Province/Region")}
                                                            name={FormFieldNames.ADDRESS_LINE4}
                                                            value={formState.addressLine4}
                                                            maxLength={256}
                                                            onChange={handleInputChange}
                                                            error={isBillingInfoSubmitted && formState.errors.addressLine4}
                                                            data-test-selector="customerAddressForm_ADDRESS_LINE4"
                                                        />
                                                    )}
                                                </GridItem>
                                                <GridItem {...styles.cityGridItem}>
                                                    <TextField
                                                        {...styles.cityText}
                                                        label={translate("City")}
                                                        name={FormFieldNames.CITY}
                                                        value={formState.city}
                                                        maxLength={256}
                                                        onChange={handleInputChange}
                                                        error={isBillingInfoSubmitted && formState.errors.city}
                                                        data-test-selector="customerAddressForm_city"
                                                    />
                                                </GridItem>

                                                <GridItem {...styles.phoneGridItem}>
                                                    <TextField
                                                        {...styles.phoneText}
                                                        label={translate("Phone")}
                                                        name={FormFieldNames.PHONE}
                                                        value={formState.phone}
                                                        min={10}
                                                        maxLength={256}
                                                        onChange={handleInputChange}
                                                        onBlur={changePhoneHandler}
                                                        error={formState.phone && formState.errors.phone}
                                                        data-test-selector="customerAddressForm_phone"
                                                    />

                                                </GridItem>
                                                <GridItem {...styles.backGridItem}>
                                                    <Button
                                                        type="button"
                                                        {...styles.backButton}
                                                        onClick={backToAccountInformationHadler}
                                                        data-test-selector="createAccount_backButton"
                                                    >
                                                        {translate("BACK")}
                                                    </Button>
                                                    <Button
                                                        {...styles.nextButton}
                                                        type="submit"
                                                        data-test-selector="createAccount_nextButton"
                                                    >
                                                        {translate("CONTINUE")}
                                                    </Button>
                                                </GridItem>
                                            </GridContainer>
                                        </StyledForm>
                                    </AccordionSection>

                                    <AccordionSection
                                        expanded={summeryTab}
                                        title={translate("Summary")} {...styles.accordionHeadGridItem}
                                    >
                                        <StyledForm ref={summeryFormRef} {...styles.form} onSubmit={submitHandler} noValidate>
                                            <GridContainer {...styles.accountInformationGridContainer}>
                                                <GridItem {...styles.accountInformationGridItemWrapper}>

                                                    <GridItem {...styles.accountInformationGridItem}>
                                                        <Icon onClick={jumpToInfoTab} onKeyDown={(e) => {
                                                            if (e.key === 'Enter' || e.key === ' ') {
                                                                e.preventDefault(); // prevent scrolling for Space
                                                                jumpToInfoTab();
                                                            }
                                                        }} src={EditIcon} size={24} tabIndex={0}
                                                            role="button" aria-label="Edit Account Information" className="edit-icon" {...styles.editIconWrapper} />

                                                        <RadioGroup
                                                            label={translate("Customer")}
                                                            data-test-selector="areyouadanacustomer"
                                                            {...styles.danaUserBoxGroupWrapper}
                                                            value={userType}
                                                        >
                                                            {userType === UserTypeConst.Customer && (
                                                                <StyledWrapper
                                                                    {...styles.danaRadioMethodWrapper}
                                                                    className="active"
                                                                >
                                                                    <Radio
                                                                        value={UserTypeConst.Customer}
                                                                        data-test-selector="areyouadanacustomer_yes"
                                                                        {...styles.danaUserBoxWrapper}
                                                                    >
                                                                        <Icon
                                                                            src={CustomerIcon}
                                                                            size={24}
                                                                            className="user-icon"
                                                                            {...styles.userIconWrapper}
                                                                        />
                                                                        <Typography>{translate("Customer")}</Typography>
                                                                    </Radio>
                                                                    {checkIcon}
                                                                </StyledWrapper>
                                                            )}

                                                            {userType === UserTypeConst.Individual && selectedLanguage && selectedLanguage?.properties?.region !== LARegion && (
                                                                <StyledWrapper
                                                                    {...styles.danaRadioMethodWrapper}
                                                                    className="active"
                                                                >
                                                                    <Radio
                                                                        value={UserTypeConst.Individual}
                                                                        data-test-selector="areyouadanacustomer_no"
                                                                        {...styles.danaUserBoxWrapper}
                                                                    >
                                                                        <Icon
                                                                            src={UserIcon}
                                                                            size={24}
                                                                            className="user-icon"
                                                                            {...styles.userIconWrapper}
                                                                        />
                                                                        <Typography>{translate("Individual")}</Typography>
                                                                    </Radio>
                                                                    {checkIcon}
                                                                </StyledWrapper>
                                                            )}
                                                        </RadioGroup>

                                                        {userType === UserTypeConst.Customer && (
                                                            <>
                                                                <Typography {...styles.accountInformationHeaderVariant} variant="h6" className="text-body-sm">{translate("Customer Account Number")}</Typography>
                                                                <Typography as="p" lineHeight={1.5}>{formState.customerAccountNumber}</Typography>
                                                            </>
                                                        )}

                                                        <Typography {...styles.accountInformationHeaderVariant} variant="h6" className="text-body-sm">{translate("Name")}</Typography>
                                                        <Typography as="p" lineHeight={1.5}>{formState.firstName} {formState.lastName}</Typography>
                                                        <Typography {...styles.accountInformationHeaderVariant} variant="h6" className="text-body-sm">{translate("Email Address (Login Id)")}</Typography>
                                                        <Typography as="p" lineHeight={1.5}>{formState.email} </Typography>
                                                    </GridItem >
                                                    {/* Billing Information */}
                                                    {(formState.companyName || formState.addressLine1 || formState.addressLine2 || formState?.city || formState.addressLine4 || formState?.postalCode || formState?.phone) && (
                                                        <>
                                                        <GridItem {...styles.billingInformationGridItem}>
                                                            <Icon onClick={jumpToBillingTab} onKeyDown={(e) => {
                                                                if (e.key === 'Enter' || e.key === ' ') {
                                                                    e.preventDefault();
                                                                    jumpToBillingTab();
                                                                }
                                                            }} src={EditIcon} size={24} tabIndex={0}
                                                                role="button" aria-label="Edit Billing Information" className="edit-icon" {...styles.editIconWrapper} />
                                                            {formState.companyName && (<>
                                                                <Typography {...styles.accountInformationHeaderVariant} variant="h6" className="text-body-sm">{translate("Company Name")}</Typography>
                                                                <Typography as="p" lineHeight={1.5}>{formState.companyName}</Typography>

                                                            </>)}
                                                            {(formState.addressLine1 || formState.addressLine2 || formState?.city || formState.addressLine4 || formState?.postalCode || formState?.phone) && (<>
                                                                <Typography {...styles.accountInformationHeaderVariant} variant="h6" className="text-body-sm">{translate("Address")}</Typography>
                                                                <Typography as="p" lineHeight={1.5}>{formState.addressLine1}</Typography>
                                                                <Typography as="p" lineHeight={1.5}>{formState.addressLine2}</Typography>
                                                                <Typography as="p" lineHeight={1.5}>{formState?.city ? `${formState?.city}, ` : ""} {state ? `${state.abbreviation}, ` : formState.addressLine4 ? `${formState.addressLine4}, ` : ''}  </Typography>
                                                                <Typography as="p" lineHeight={1.5}> {formState?.postalCode ? `${formState?.postalCode}, ` : ""} {country?.name}</Typography>
                                                                {formState?.phone && (
                                                                    <>
                                                                        <Typography {...styles.accountInformationHeaderVariant} variant="h6" className="text-body-sm">{translate("Phone (Work)")}</Typography>
                                                                        <Typography as="p" lineHeight={1.5}>{country?.abbreviation} <GlobalPhoneFormat phone={formState?.phone}></GlobalPhoneFormat></Typography>
                                                                    </>)
                                                                }
                                                            </>)}
                                                        </GridItem>
                                                    </>
                                                )}

                                                </GridItem>

                                                <GridItem {...styles.confirmationSigninCheckGridItem}>
                                                    <CheckboxGroup {...styles.privacyPolicyCheckboxGroup}>
                                                        <div className="tooltip-wrapper">
                                                            <Checkbox {...styles.privacyPolicyCheckbox}
                                                                onChange={(e, value) => setIsSubscribed(!isSubscribed)}
                                                                checked={isSubscribed}
                                                                data-test-selector="createAccount_confirmationSigninCheck"
                                                            >
                                                                {termsLabelMessage}
                                                                <span className="tooltip-text">{termsErrorMessage}</span>
                                                            </Checkbox>
                                                        </div>
                                                    </CheckboxGroup>
                                                </GridItem>

                                                {isSubmitting && !isSubscribed && (
                                                    <GridItem data-test-selector="createAccount_ErrorMessage" {...styles.submitErrorGridItem}>
                                                        <Typography {...styles.submitErrorTitle}>{termsErrorMessage}</Typography>
                                                    </GridItem>
                                                )}
                                                <GridItem {...styles.submitGridItem}>
                                                    <Button
                                                        {...styles.submitButton}
                                                        type="submit"
                                                        disabled={isSubmitted}
                                                        data-test-selector="createAccount_createButton"
                                                    >
                                                        {translate("Sign Up")}
                                                    </Button>
                                                </GridItem>
                                            </GridContainer>
                                        </StyledForm>
                                    </AccordionSection>
                                </Accordion>
                            </GridItem>
                        </GridContainer>
                    </GridItem>
                </GridContainer>
            </LoadingOverlay>
        </>
    );
};


const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withHistory(CreateAccount)),
    definition: {
        allowedContexts: ["CreateAccountPage"],
        group: "Create Account",
    },
};

export default widgetModule;
